import React, { useState, useEffect } from 'react';
import { login, logout, isAuthenticated, getUserInfo } from '../services/keycloak';
import './AuthButton.css';

const AuthButton = () => {
  const [authenticated, setAuthenticated] = useState(false);
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    setAuthenticated(isAuthenticated());
    if (isAuthenticated()) {
      setUserInfo(getUserInfo());
    }
  }, []);

  const handleLogin = () => {
    login();
  };

  const handleLogout = () => {
    logout();
  };

  if (authenticated && userInfo) {
    return (
      <div className="auth-container">
        <span className="user-info">
          👤 {userInfo.email || userInfo.username}
        </span>
        <button onClick={handleLogout} className="logout-btn">
          Logout
        </button>
      </div>
    );
  }

  return (
    <button onClick={handleLogin} className="login-btn">
      Login
    </button>
  );
};

export default AuthButton;
